import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  Validators
} from '@angular/forms';

import { State } from '../../../vista-usuario/vista-usuario.state';
import { Store } from '@ngrx/store';
import { selectAllPaises } from '../../../ubicaciones/entity-paises/entity-paises.selectors';
import { Observable, Subscription } from 'rxjs';
import { Pais } from '@rpe/registro-personas-empresas-lib';
import { ROUTE_ANIMATIONS_ELEMENTS } from 'projects/registro-personas-empresas/src/app/core/core.module';
import { environment } from 'projects/registro-personas-empresas/src/environments/environment';
import { Telefono, TelefonoFormInput } from '../telefonos.model';
import { SelectionChange } from '@angular/cdk/collections';

@Component({
  selector: 'rpe-telefonos-form',
  templateUrl: './telefonos-form.component.html',
  styleUrls: ['./telefonos-form.component.css']
})
export class TelefonosFormComponent implements OnInit, OnDestroy {
  @Input()
  set formInput(telefonoFormInput: TelefonoFormInput) {
    if (telefonoFormInput) {
      this._formInput = telefonoFormInput;
      this.cargaParam = true;
      this.setTelefonos();
    }
  }
  get formInput(): TelefonoFormInput {
    return this._formInput;
  }

  @Output() formStatusChanges = new EventEmitter<string>();
  @Output() formValueChanges = new EventEmitter<Telefono[]>();

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  _formInput: TelefonoFormInput;

  paisSelected: Pais[] = [];
  paises: Pais[];
  defaultPais: Pais;
  preSetPais: Pais = null;
  telefonosFormGroup = this.fb.group({
    telefonos: this.fb.array([])
  });
  subscription: Subscription;
  cargaInit = false;
  cargaParam = false;

  constructor(private fb: FormBuilder, private store: Store<State>) {}

  ngOnInit(): void {
    this.subscription = this.store
      .select(selectAllPaises)
      .subscribe((paises) => {
        this.paises = paises;
        if (paises && paises.length > 0) {
          this.cargaInit = true;
          this.setTelefonos();
        }
      });

    // emit events
    this.telefonosFormGroup.valueChanges.subscribe((e) => {
      this.emitChanges();
    });

    this.telefonosFormGroup.statusChanges.subscribe((s) => {
      this.formStatusChanges.emit(s);
    });
  }

  emitChanges() {
    let retTel: Telefono[] = [];
    this.telefonosFormGroup.value.telefonos.forEach((t: any) => {
      const tel: Telefono = {
        id: null,
        pais_codigo: t.pais_codigo?.codigo,
        telefono: t.telefono
      };
      retTel.push(tel);
    });
    this.formValueChanges.emit(retTel);
  }

  setTelefonos() {
    if (this.cargaInit && this.cargaParam) {
      if (this._formInput.preSelectPais) {
        this.preSetPais = this.paises.find(
          (p) => p.codigo == this._formInput.preSelectPais
        );
      }
      if (this._formInput.telefonos && this._formInput.telefonos.length > 0) {
        // Cargo los telefonos que tiene
        if (this._formInput.defaultPais) {
          this.defaultPais = this.paises.find(
            (p) => p.codigo == this._formInput.defaultPais
          );
        }
        this.loadTelefonos(this._formInput.telefonos);
      } else {
        if (this._formInput.defaultPais) {
          this.defaultPais = this.paises.find(
            (p) => p.codigo == this._formInput.defaultPais
          );
          this.agregarTelefonoPais(this.defaultPais);
        } else {
          this.agregarTelefono();
        }
      }
      //console.log(this.telefonosFormGroup);
      //console.log('QUE EMITO', this.telefonosFormGroup.status);
      this.emitChanges();
      this.formStatusChanges.emit(this.telefonosFormGroup.status);
    }
  }

  loadTelefonos(telefonos: Telefono[]) {
    telefonos.forEach((tel) => {
      let p: Pais;
      if (tel.pais_codigo) {
        p = this.paises.find((pais) => pais.codigo == tel.pais_codigo);
      } else {
        if (this.preSetPais) {
          p = this.preSetPais;
        } else {
          p = null;
        }
      }
      const telFG = this.fb.group({
        pais_codigo: [p, [Validators.required]],
        telefono: [tel.telefono, [Validators.required]]
      });
      if (this.formInput.preSelectPais === 'uy' && p && p.codigo === 'uy') {
        // Agregar validaciones de mín 8 máx 9 dígitos
        telFG
          .get('telefono')
          .addValidators([Validators.minLength(8), Validators.maxLength(9)]);
      }
      this.paisSelected.push(p);
      this.telefonos().push(telFG);
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  telefonos(): FormArray {
    return this.telefonosFormGroup.get('telefonos') as FormArray;
  }

  agregarTelefono() {
    const telFG = this.fb.group({
      pais_codigo: [this.preSetPais, [Validators.required]],
      telefono: [, [Validators.required]]
    });
    if (this.formInput.preSelectPais === 'uy') {
      // Agregar validaciones de mín 8 máx 9 dígitos
      telFG
        .get('telefono')
        .addValidators([Validators.minLength(8), Validators.maxLength(9)]);
    }
    this.paisSelected.push(this.preSetPais);
    this.telefonos().push(telFG);
  }

  eliminarTelefono(index: number) {
    this.telefonos().removeAt(index);
    this.paisSelected.splice(index, 1);
  }

  agregarTelefonoPais(p: Pais) {
    const telFG = this.fb.group({
      pais_codigo: [p, [Validators.required]],
      telefono: [, [Validators.required]]
    });
    if (this.formInput.preSelectPais === 'uy' && p.codigo === 'uy') {
      // Agregar validaciones de mín 8 máx 9 dígitos
      telFG
        .get('telefono')
        .addValidators([Validators.minLength(8), Validators.maxLength(9)]);
    }
    this.paisSelected.push(p);
    this.telefonos().push(telFG);
  }

  checkErrors() {
    console.log('llego al on chack error de telefonos');
    this.telefonosFormGroup.markAllAsTouched();
  }

  onPaisSelected(event: any, control: AbstractControl): void {
    if (event.codigo === 'uy') {
      control
        .get('telefono')
        .addValidators([Validators.minLength(8), Validators.maxLength(9)]);
    } else {
      control.get('telefono').clearValidators();
      control.get('telefono').addValidators([Validators.required]);
    }
    control.get('telefono').updateValueAndValidity();
  }
}
